import { useState } from 'react';
import { Input } from '@/components/ui/input.js';
import { Search } from 'lucide-react';
import { ChatHistoryList } from './ChatHistoryList.js';

interface ConversationsPanelProps {
  onSelect?: () => void;
}

export function ConversationsPanel({ onSelect }: ConversationsPanelProps) {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="flex flex-col h-full">
      {/* Header - hidden on mobile since MobileSheet has its own */}
      <div className="p-4 border-b border-border/50 md:block hidden">
        <h2 className="text-lg font-semibold mb-3">Conversations</h2>

        {/* Search */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search conversations..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-9 h-9"
          />
        </div>
      </div>

      {/* Mobile header with search */}
      <div className="p-4 md:hidden">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search conversations..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-9 h-10"
          />
        </div>
      </div>

      {/* Chat History */}
      <div className="flex-1 overflow-hidden">
        <ChatHistoryList searchQuery={searchQuery} onSelect={onSelect} />
      </div>
    </div>
  );
}
